import { render, staticRenderFns } from "./PlanningDetails.vue?vue&type=template&id=085aaf36&"
import script from "./PlanningDetails.vue?vue&type=script&lang=js&"
export * from "./PlanningDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports